import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconZoomIn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	fill: "none",
	viewBox: "0 0 13 13",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M8.177 7.458H7.8l-.135-.129c.47-.546.753-1.255.753-2.027 0-1.72-1.395-3.114-3.115-3.114-1.72 0-3.114 1.394-3.114 3.114s1.394 3.115 3.114 3.115c.772 0 1.48-.283 2.027-.753l.13.135v.378l2.395 2.391.714-.714-2.39-2.396zm-2.875 0c-1.193 0-2.156-.963-2.156-2.156s.963-2.156 2.156-2.156 2.156.963 2.156 2.156-.963 2.156-2.156 2.156zM6.5 5.542h-.958V6.5h-.48v-.958h-.958v-.48h.958v-.958h.48v.958H6.5v.48z"
	})
});
export default SvgIconZoomIn;
